/**
 * Relógio do servidor. A abertura do estúdio segue a hora da API (é ela que recusa sortear antes do
 * horário), então a contagem regressiva não pode depender do relógio do computador do influenciador.
 * Uma leitura de /api/health dá a diferença; se falhar, usa o relógio local e tenta de novo depois.
 */
let offset = 0;
let pending: Promise<void> | null = null;

export function syncClock(): Promise<void> {
  if (!pending) {
    pending = (async () => {
      try {
        const t0 = Date.now();
        const res = await fetch('/api/health', { cache: 'no-store' });
        const t1 = Date.now();
        const { time } = (await res.json()) as { time?: string };
        const server = time ? Date.parse(time) : NaN;
        if (Number.isFinite(server)) offset = server - (t0 + t1) / 2;
      } catch {
        pending = null; // sem conexão: tenta na próxima chamada
      }
    })();
  }
  return pending;
}

/** Agora, na hora do servidor (ms). */
export const serverNow = (): number => Date.now() + offset;
